var _circle, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockRedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7935_21104)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#D32F2F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7935_21104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7935_21104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 46.5C17.5375 46.5 16.7135 46.1573 16.0281 45.4719C15.3427 44.7865 15 43.9625 15 43V25.5C15 24.5375 15.3427 23.7135 16.0281 23.0281C16.7135 22.3427 17.5375 22 18.5 22H20.25V18.5C20.25 16.0792 21.1031 14.0156 22.8094 12.3094C24.5156 10.6031 26.5792 9.75 29 9.75C31.4208 9.75 33.4844 10.6031 35.1906 12.3094C36.8969 14.0156 37.75 16.0792 37.75 18.5V22H39.5C40.4625 22 41.2865 22.3427 41.9719 23.0281C42.6573 23.7135 43 24.5375 43 25.5V43C43 43.9625 42.6573 44.7865 41.9719 45.4719C41.2865 46.1573 40.4625 46.5 39.5 46.5H18.5ZM18.5 43H39.5V25.5H18.5V43ZM29 37.75C29.9625 37.75 30.7865 37.4073 31.4719 36.7219C32.1573 36.0365 32.5 35.2125 32.5 34.25C32.5 33.2875 32.1573 32.4635 31.4719 31.7781C30.7865 31.0927 29.9625 30.75 29 30.75C28.0375 30.75 27.2135 31.0927 26.5281 31.7781C25.8427 32.4635 25.5 33.2875 25.5 34.25C25.5 35.2125 25.8427 36.0365 26.5281 36.7219C27.2135 37.4073 28.0375 37.75 29 37.75ZM23.75 22H34.25V18.5C34.25 17.0417 33.7396 15.8021 32.7188 14.7812C31.6979 13.7604 30.4583 13.25 29 13.25C27.5417 13.25 26.3021 13.7604 25.2812 14.7812C24.2604 15.8021 23.75 17.0417 23.75 18.5V22Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7935_21104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockRedIcon);
export default __webpack_public_path__ + "static/media/lock-red-icon.1f1e6a3fd0ccb067ec5eb6534552e36b.svg";
export { ForwardRef as ReactComponent };